import {
    errorFetchingRequestState,
    getInitialRequestState,
    RequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";
import {
    PROJECT_PHASE_TASK_NEXT_ID,
    PROJECT_PHASE_TASK_NEXT_ID_ERROR,
    PROJECT_PHASE_TASK_NEXT_ID_SUCCESS,
    ProjectProjectStagePhaseTaskViewActionTypes,
    UPDATE_PHASE_TASK_PERFORMANCE,
    UPDATE_PHASE_TASK_PERFORMANCE_ERROR,
    UPDATE_PHASE_TASK_PERFORMANCE_SUCCESS
} from "../../actions/projects/ProjectStagePhaseTaskActions";


export interface ProjectStagePhaseTaskState {
    changingRequest: RequestState
    nextId: {
        value: number
        request: RequestState
    }
}

const initialState: ProjectStagePhaseTaskState = {
    changingRequest: getInitialRequestState(),
    nextId: {
        value: 0,
        request: getInitialRequestState()
    }
};

export function ProjectStagePhaseTaskReducer(
    state: ProjectStagePhaseTaskState = initialState,
    action: ProjectProjectStagePhaseTaskViewActionTypes
) {

    switch( action.type ) {
        case UPDATE_PHASE_TASK_PERFORMANCE:
            return {
                ...state,
                changingRequest: startFetchingRequestState()
            };
        case UPDATE_PHASE_TASK_PERFORMANCE_SUCCESS:
            return {
                ...state,
                changingRequest: successFetchingRequestState()
            };
        case UPDATE_PHASE_TASK_PERFORMANCE_ERROR:
            return {
                ...state,
                changingRequest: errorFetchingRequestState( action.error )
            };
        case PROJECT_PHASE_TASK_NEXT_ID:
            return {
                ...state,
                nextId: {
                    value: 0,
                    request: startFetchingRequestState()
                }
            };
        case PROJECT_PHASE_TASK_NEXT_ID_SUCCESS:
            return {
                ...state,
                nextId: {
                    value: action.payload,
                    request: successFetchingRequestState()
                }
            };
        case PROJECT_PHASE_TASK_NEXT_ID_ERROR:
            return {
                ...state,
                nextId: {
                    value: 0,
                    request: errorFetchingRequestState( action.error )
                }
            };
        default:
            return state;
    }

}